import type { FaireProductEntity } from "../../entity_types/product";

export const p_7jhfwp87he: FaireProductEntity = {
  token: "p_7jhfwp87he",
  type: "product",
  name: "Black & White Checkered Enamel Huggies",
  brandToken: "b_8qax1plboc",
  brandName: "Nickel and Suede",
  imageUrl:
    "https://cdn.faire.com/fastly/d85bb4067cf5cf531570638cf70224c37763b59ecd7a4673f3e07da5a4fbedcd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d52386170cd29911d80c8e1d62d19901cbe7b14b27573dd1ee5a927c8a45b46.jpeg",
    "https://cdn.faire.com/fastly/c67d53dadbe0d4415f345e4a1ca7394e7b41e76b26dd319e7aa322dc3e946855.jpeg",
    "https://cdn.faire.com/fastly/034b2e4a842ac546c105d69e54fc134f96c8a05bc4b57158b288279569b091ef.jpeg",
  ],
  priceDollars: 18,
  description:
    "The black and white checkered enamel huggies are a wide, small gold hoop with black and white enamel that fits closely to the ear. They feature a hinge closure for comfort and wearability. \n",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:43.554Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
